import { AxiosError } from 'axios';
import { useCustomQuery } from '../utils/useCustomQuery';
import {
  GET_UNIQUE_LINK_DETAILS_QUERY_KEY,
  GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_QUERY_KEY,
} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {
  GET_UNIQUE_LINK_DETAILS_URL,
  GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_URL,
} from '../../constants/apiUrls';

interface UniqueLinkPaper {
  paperNo: string;
  selected: boolean;
}

interface UniqueLinkSubjectDetails {
  subjectName: string;
  subjectCode: string;
  subjectLevel: string;
  examSeries: string;
  examLevel: string;
  subjectType: string;
  papers: UniqueLinkPaper[];
}

interface UniqueLinkDetailsResponse {
  isWaiveSubjectAdminFee: boolean;
  isWaiveLateFee: boolean;
  exemptionRules: string[];
  subjects: UniqueLinkSubjectDetails[];
  expiryDate: string;
}

interface Input {
  token?: string;
  onSuccess?: (data: UniqueLinkDetailsResponse) => void;
  onError?: (data: AxiosError) => void;
  enabled?: boolean;
}

export const useGetUniqueLinkDetails = ({ token, onSuccess, onError, enabled = false }: Input) => {
  const getUniqueLinkDetails = async () => {
    const res = await axiosClient.get<UniqueLinkDetailsResponse>(
      GET_UNIQUE_LINK_DETAILS_URL(token)
    );
    return res.data;
  };

  return useCustomQuery(GET_UNIQUE_LINK_DETAILS_QUERY_KEY, getUniqueLinkDetails, {
    onSuccess,
    onError,
    enabled,
  });
};

export const useGetWithdrawalUniqueLinkDetails = ({
  token,
  onSuccess,
  onError,
  enabled = false,
}: Input) => {
  const getUniqueLinkDetails = async () => {
    const res = await axiosClient.get<UniqueLinkDetailsResponse>(
      GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_URL(token)
    );
    return res.data;
  };

  return useCustomQuery(GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_QUERY_KEY, getUniqueLinkDetails, {
    onSuccess,
    onError,
    enabled,
  });
};
